// extracted by mini-css-extract-plugin
export default {"container":"DialogContainer_container__4u13Z","spacer":"DialogContainer_spacer__ZD+Uc"};